export default "__VITE_ASSET__CUhBvf3t__"